import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CommunicationMessageType } from './communication-message-type.interface';
import { CommunicationMessageTypeService } from './communication-message-type.service';

const service = new CommunicationMessageTypeService();

export interface CommunicationMessageTypeState {
   communicationMessageTypes: Array<CommunicationMessageType>;
}

const CommunicationMessageTypeStore: Module<CommunicationMessageTypeState, StoreState> = {
   namespaced: true,
   state: {
      communicationMessageTypes: [],
   },
   getters: {},
   mutations: {
      SET_COMMUNICATION_MESSAGE_TYPES(state, communicationMessageTypes: Array<CommunicationMessageType>) {
         state.communicationMessageTypes = communicationMessageTypes;
      },
   },
   actions: {
      async getCommunicationMessageTypes(context, query?: LocationQuery) {
         const response = await service.getCommunicationMessageTypes(query);
         context.commit('SET_COMMUNICATION_MESSAGE_TYPES', response.data);
         return response.data;
      },
   },
};

export default CommunicationMessageTypeStore;
